module.exports = __webpack_public_path__ + "media/assets/images/layout/bg-upload-1a9906920f2dbea20a4038c1c2d50721.png";